<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NzNpKV/tc-custom/9781426829703.jpg?1705766125699" alt="This image is the cover for the book Italian's Ruthless Marriage Bargain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Italian's Ruthless Marriage Bargain
      </h1>
      <p class="bookDescription body article font2">
        <p>Plain, poor and inexperienced, Jude struggles to hold down a full-time job as well as being guardian to her brother's three little children. So she can't believe her eyes when she opens her front door to handsome Luca Di Rossi, the man whom the newspapers call the world's most notorious playboy!<br/><br/>Jude knows that in any other circumstances, wealthy, powerful Luca wouldn't look twice at her. But he needs a wife<i>pronto!</i> Now the ruthless billionaire's demanding a marriage of convenience!<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Lawrence
      </h2>
      
      <p class="authorDescription body article">Kim Lawrence was encouraged by her husband to write when the unsocial hours of nursing didn&rsquo;t look attractive! He told her she could do anything she set her mind to, so Kim tried her hand at writing. Always a keen Mills &amp; Boon reader, it seemed natural for her to write a romance novel &ndash; now she can&rsquo;t imagine doing anything else. She is a keen gardener and cook and enjoys running on the beach with her Jack Russell. Kim lives in Wales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bdaaa42c